import { Injectable } from '@angular/core';
import { GlobalTrackingService } from '../../../SGRE-shared/services/global-tracking.service';
import { StorageService } from '../../../SGRE-shared/services/storage.service';
import { Router } from '@angular/router';
import { AuthService, LanguageService } from '@spartacus/core';
import { ActionType, LoginStatus, pageData, PageReadyData, userData, Country } from '../../../SGRE-shared/models/global-tracking.model';
import { take } from 'rxjs';
import { pageIds } from '../../../SGRE-shared/constants/app-constant';

@Injectable({
  providedIn: 'root'
})
export class LanguageSelectorTrackingService {
private previousLanguage: string = 'en';

  constructor(
    private globalTrackingService: GlobalTrackingService,
    private languageService: LanguageService,
    private router: Router,
    private authService: AuthService
  ) {}

  /**
   * Track language switch event using GlobalTrackingService
   */
  


trackLanguageSwitch(toLang: string, clickTarget?: HTMLElement): void {
  this.languageService.getActive().pipe(take(1)).subscribe((currentLang) => {
    const mappedFrom = this.mapLanguageCode(this.previousLanguage);
    const mappedTo = this.mapLanguageCode(toLang); // Use toLang directly

    const trackingData = {
      language: {
        from: mappedFrom,
        to: mappedTo
      }
    };

    this.globalTrackingService.sendTrackingEvent('language.switch', trackingData, clickTarget!);

    // Update previous language AFTER tracking
    this.previousLanguage = currentLang;
  });
}

  private mapLanguageCode(code: string): string {
    const map: { [key: string]: string } = {
      'en': 'en-US',
      'de': 'de-DE',
      'es': 'es-ES'
    };
    return map[code] || code;
  }


  // Optional: You can also delegate dropdown open/close/hover events similarly
  trackLanguageDropdownOpen(currentLang: string, clickTarget: HTMLElement): void {
    this.globalTrackingService.sendTrackingEvent('language.dropdown.open', { currentLanguage: currentLang }, clickTarget);
  }

  trackLanguageDropdownClose(currentLang: string): void {
    this.globalTrackingService.sendTrackingEvent('language.dropdown.close', { currentLanguage: currentLang }, document.body);
  }

  trackLanguageHover(hoveredLang: string, currentLang: string, clickTarget: HTMLElement): void {
    this.globalTrackingService.sendTrackingEvent('language.hover', {
      hoveredLanguage: hoveredLang,
      currentLanguage: currentLang
    }, clickTarget);
  }

  trackPageViewWithLanguage(currentLang: string): void {
    this.globalTrackingService.sendTrackingEvent('page.view.language', {
      currentLanguage: this.mapLanguageCode(currentLang)
    }, document.body);
  }
}